<template>
  <div>
    <topsearch title="Agent Raporu" />

    <div class="flex">
      <div class="w-72 border-r h-full">
        <SidebarVue />
      </div>
      <div class="w-full">
        <div class="overflow-scroll min-h-screen md:p-4" v-if="chart_series">
          <apexchart
            type="bar"
            class="w-full lg:w-3/4"
            :options="chart_options"
            :series="chart_series"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

import SidebarVue from "../components/Ui/Admin/Sidebar.vue";
import languageKey from "../components/Ui/Form/languageKey.vue";
import http from "../services/http";
export default {
  components: { apexchart: VueApexCharts, SidebarVue, languageKey },
  name: "reportUtm",
  data() {
    return {
      chart_series: [],
      chart_options: {
        chartType: "bar",
        chart: {
          type: "bar",
          height: 350,
          stacked: true
        },
        stacked: true,
        xaxis: {
          categories: []
        },
        plotOptions: {
          bar: {
            horizontal: true,
            dataLabels: {
              total: {
                enabled: true,
                offsetX: 0,
                style: {
                  fontSize: "13px",
                  fontWeight: 900
                }
              }
            }
          }
        }
      },
      data: [],
      statuses: [],
      utmKey: "agent_id"
    };
  },
  created() {
    this.getData();
  },
  methods: {
    nameConvert(name) {
      if (this.utmKey == "agent_id") {
        return this.$root.getVal(15, name);
      }
      if (this.utmKey == "country_id") {
        return this.$root.getVal(37, name);
      }
      return name;
    },
    getData() {
      if (this.$root.cache.getOptions[15]) {
        this.chart_options.xaxis.categories = this.$root.cache.getOptions[15].map(
          e => e.label
        );
      }
      http.getAgentReport({ utmKey: this.utmKey }).then(response => {
        this.chart_series = response.data.result;
        console.log(this.chart_series,"chart_series");
      });
    }
  }
};
</script>

<style></style>
